
import CheckboxField from '@/components/processing_steps/commons/fields/CheckboxField.vue'
import SingleSelectField from '@/components/processing_steps/commons/fields/SingleSelectField.vue'
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import Reversions from '@/components/processing_steps/commons/Reversions.vue'
import OrgaValidationMixin from '@/mixins/OrgaValidationMixin'
import { IPSAdminEditOrganization, IPSAdminOrgaCompletionForm, IPSSelectOption } from '@/types/processingSteps'
import { Component, Mixins, Prop } from 'vue-property-decorator'

@Component({
  components: {
    FormContainer,
    CheckboxField,
    SingleSelectField,
    Reversions
  }
})
export default class AdminOrgaCompletitionForm extends Mixins(OrgaValidationMixin) {
  // todo: remove organization and set the other select options as for available_content_review_status
  @Prop() organization!: IPSAdminEditOrganization
  @Prop() completitionForm: IPSAdminOrgaCompletionForm
  @Prop() available_content_review_status: IPSSelectOption[]
}
